import React from 'react';
import StatementExplorer from '../components/finance/statement_explorer';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Index({}) {
    return <StatementExplorer />;
}
